import TOP_BARS from '@topBars';
import FOOTERS from '@footers';
let routes = [
  /**
   * @description H/XWeek 申请页
   * @function /hxweek/apply H/XWeek申请
   */
  {
    path: '/hxweek/apply',
    name: 'hxweek-apply',
    meta: {
      title: 'H/XWeek申请页'
    },
    component: () => import('@/views/HWeek/Apply')
  },
  {
    path: '/h-week/apply',
    redirect: '/hxweek/apply'
  },
  /**
   * @description HXWeek 面试锦囊
   * @function /hxweek/interview-tips HXWeek面试小贴士
   */
  {
    path: '/hxweek/interview-tips',
    name: 'hxweek-interview-tips',
    meta: {
      title: 'HXWeek面试锦囊',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/HWeek/InterviewTips')
  },
  /**
   * @description H/XWeek 定金支付
   * @function /hxweek/pay H/XWeek支付
   */
  {
    path: '/hxweek/pay',
    name: 'hxweek-pay',
    meta: {
      title: 'H/XWeek支付'
    },
    component: () => import('@/views/HWeek/Pay')
  },
  {
    path: '/hx-week/pay',
    redirect: '/hxweek/pay'
  },
  /**
   * @description 确认你的护照和签证状态
   * @function /hxweek/passport
   */
  {
    path: '/hxweek/passport',
    name: 'hxweek-passport',
    meta: {
      title: '确认你的护照和签证状态',
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'dashboard',
        query: {
          tab: 'HXWEEK'
        }
      }
    },
    component: () => import('@/views/HWeek/Passport')
  },
  /**
   * @description H/XWeek 签证办理指南
   * @function /hxweek/visa
   */
  {
    path: '/hxweek/visa',
    name: 'hxweek-visa',
    meta: {
      title: '签证办理指南',
      topBar: TOP_BARS.NULL,
      backDefault: {
        name: 'dashboard',
        query: {
          tab: 'HXWEEK'
        }
      }
    },
    component: () => import('@/views/HWeek/Visa')
  },
  /**
   * @description HWeek 行前重要文件签署和下载
   * @function /hxweek/pre-trip
   */
  {
    path: '/hxweek/pre-trip',
    name: 'hxweek-pre-trip',
    meta: {
      title: '行前重要文件签署和下载',
      topBar: TOP_BARS.BACK,
      backDefault: {
        name: 'dashboard',
        query: {
          tab: 'HXWEEK'
        }
      }
    },
    component: () => import('@/views/HWeek/Files')
  },
  /**
   * @description H/XWeek 尾款支付
   * @function /hxweek/final-payment
   */
  {
    path: '/hxweek/final-payment',
    name: 'hxweek-final-payment',
    meta: {
      title: 'H/XWeek'
    },
    component: () => import('@/views/HWeek/BalancePayment')
  },
  /**
   * @description H/XWeek 课程聚合
   * @function /hxweek/course
   */
  {
    path: '/hxweek/course',
    name: 'hxweek-course',
    meta: {
      title: 'H/XWeek'
    },
    component: () => import('@/views/HWeek/Course')
  },
  /**
   * @description H/XWeek NHP 支付
   * @function /hxweek/pay/nhp
   */
  {
    path: '/hxweek/pay/nhp',
    name: 'hxweek-pay-nhp',
    component: () => import('@/views/HWeek/Pay/NHP')
  },
  {
    path: '/hx-week/pay/nhp',
    redirect: '/hxweek/pay/nhp'
  }
];
routes = routes.map(item => {
  let ret = { ...item };
  ret.meta = {
    topBar: TOP_BARS.DEFAULT,
    ...ret.meta
  };
  return ret;
});
export default routes;
